import * as types from "./actionTypes";

export const setMenu = () => ({
  type: types.SET_MENU,
});
